
  <div class="row justify-content-center">

  

              <form [formGroup]="formGroup" (ngSubmit)="ResetPassword()">
                  <h1 class="row justify-content-center mt-2"><b>{{ 'RESETPASSWORD.TITLE' | translate
                            }}</b></h1>

                  <h3 class="text-center"> {{ 'RESETPASSWORD.TITLE2' | translate }}</h3>

                  <div class="row justify-content-center">
                   <mat-form-field class="col-10">
                    <input matInput
                            [type]="hidePassword ? 'password' : 'text'"
                            [placeholder]="'RESETPASSWORD.PASSWORD' | translate"
                            formControlName="password">

                    <button mat-icon-button matSuffix type="button"
                            (click)="hidePassword = !hidePassword">
                        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>

                    <mat-error *ngIf="formGroup.get('password')?.touched">
                        {{ getErrorPassword() | translate }}
                    </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="row justify-content-center">
                  <mat-form-field class="col-10">
                    <input matInput
                            [type]="hideConfirmPassword ? 'password' : 'text'"
                            [placeholder]="'RESETPASSWORD.CONFIRM_PASSWORD' | translate"
                            formControlName="confirmPassword">

                    <button mat-icon-button matSuffix type="button"
                            (click)="hideConfirmPassword = !hideConfirmPassword">
                        <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>

                    <mat-error *ngIf="formGroup.hasError('mustMatch') && formGroup.get('confirmPassword')?.touched">
                        {{ 'RESETPASSWORD.ERRORS.MISMATCH' | translate }}
                    </mat-error>
                    </mat-form-field>

                  </div>

                  <div class="row justify-content-center">
                  <div class="password-rules col-10 mt-2">
                    <div [class.valid]="hasMinLength()">
                        ✔ {{ 'RESETPASSWORD.RULES.MIN_LENGTH' | translate }}
                    </div>
                    <div [class.valid]="hasUpperCase()">
                        ✔ {{ 'RESETPASSWORD.RULES.UPPERCASE' | translate }}
                    </div>
                    <div [class.valid]="hasLowerCase()">
                        ✔ {{ 'RESETPASSWORD.RULES.LOWERCASE' | translate }}
                    </div>
                    <div [class.valid]="hasNumber()">
                        ✔ {{ 'RESETPASSWORD.RULES.NUMBER' | translate }}
                    </div>
                    <div [class.valid]="hasSpecialChar()">
                        ✔ {{ 'RESETPASSWORD.RULES.SPECIAL' | translate }}
                    </div>
                    </div>

                    </div>


                  <div class="row justify-content-center my-3">
                      <button mat-raised-button color="primary" type="submit"
                                class="col-8 col-md-4 primary-bouton">
                        {{ 'RESETPASSWORD.SUBMIT' | translate }}
                        </button>
                  </div>

              </form>
     

</div>